module.exports = __webpack_public_path__ + "assets/img/e7e9ba8e8e40850173fb8e81d580c69d.png";